import AuthProvider from './controllers/users/AuthProvider';
import AppRouter from './routers/AppRouter';

function App() {
  return (
    <AuthProvider>
      <div className='wrapper'>
        <AppRouter />
      </div>
    </AuthProvider>
  );
}

export default App;